var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVisaLogo = function SvgVisaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.211,
    y: 0.208,
    width: 31.583,
    height: 21.23,
    rx: 2.292,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 0.417
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.717 14.664H7.78L6.325 9.192c-.069-.251-.215-.474-.43-.579a6.37 6.37 0 00-1.778-.579v-.21H7.24a.81.81 0 01.808.684l.754 3.946 1.938-4.63h1.885l-2.908 6.84zm3.985 0H11.87l1.507-6.84h1.831l-1.507 6.84zm3.877-4.945c.054-.369.377-.58.754-.58a3.452 3.452 0 011.777.316l.323-1.473a4.69 4.69 0 00-1.669-.316c-1.777 0-3.07.947-3.07 2.262 0 1 .916 1.526 1.562 1.842.7.316.97.527.915.842 0 .473-.538.684-1.076.684a4.67 4.67 0 01-1.885-.421l-.323 1.473a5.345 5.345 0 001.992.368c1.993.053 3.23-.894 3.23-2.315 0-1.789-2.53-1.894-2.53-2.682zm8.939 4.945l-1.454-6.84h-1.561a.81.81 0 00-.755.526l-2.692 6.314h1.885l.376-1h2.316l.216 1h1.669zM23.77 9.666l.538 2.577H22.8l.97-2.577z",
    fill: "#172B85"
  })));
};
export default SvgVisaLogo;